<template>
  <div class="d-flex justify-content-center align-items-center error-container mt-5">
    <div class="text-center">
      <img src="@/assets/img/wanasa 404.png" class="error_img"/>
      
      <div class="error-text">
        <p>Uh-oh!</p>
      <p>You are in a no-man’s-land!</p>
      </div>
      <div class="text-center mt-4">
        <router-link to="/" class="retry-btn">Click To Go to Our Home Page</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";

export default {
  name: "homepage",
  components: { Slick },
  metaInfo: {
    title: "perfect",
    titleTemplate: null
  },
  data() {
    return {
      msg: "Welcome to Your 404 Page",
      slickOptions: {
        slidesToShow: 3
      },
      shows: {}
    };
  },
  beforeMount() {
    // this.getNowShowingData();
  },
  methods: {
    getNowShowingData: function() {
      let payload = {};
      // console.log('test2', this.dropDowns.cinemaChain.selected)
      // if(this.dropDowns.cinemaChain.selected.OrganizationName != 'All Cinemas'){
      // console.log('test3', this.dropDowns.cinemaChain.selected)
      //     payload.organisationID = this.dropDowns.cinemaChain.selected.OrganisationID;
      // }
      // if(this.dropDowns.languages.selected.Title != 'All Languages'){
      //     payload.language = this.dropDowns.languages.selected.Title;
      // };
      // if(this.$persistStore.get("accessToken")){
      //     payload.accessToken = this.$persistStore.get("accessToken");
      // };

      // payload.CountryID = this.getCountryFromLocalStorage().CountryID;
      payload.CountryID = 5;
      payload.LanguageID = 1;
      makeRequestDirect("/GetAllShow", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          console.log("movie", error, res);
          if (!error && res.data.Status) {
            const { data } = res.data;
            let arr = [];
            console.log("t3", res);
            this.shows = res.data;
            res.data.shows.map(x => {
              // x.Movies.map(function(y,_index){
              //     y['url'] =  "/movie-details-page?movieId=" + y.ID;
              //     y['bookingURL'] =  "/movie-details-page?movieId=" + y.ID + '&timing=1';
              // })
            });

            //                         this.banners = res.data.Banner;
            //                         console.log('banners',this.banners)
            // //                      for(let movie in res.data.shows[0]){
            // //                          console.log()
            // //                          movie["url"] = "/movie-details-page?movieId=" + movie.ID;
            // //                        arr.push(movie);
            // //                      }
            //                       this.nowShowing = res.data.shows[0];
            //                       this.comingSoon = res.data.shows[1];
            //                       this.artHouse = res.data.shows[2];
            //                       if(this.movieFilterValue == 'Now Showing'){
            //                           this.listingMovies = res.data.shows[0];
            //                       }else if(this.movieFilterValue == 'Coming Soon'){
            //                       this.listingMovies = res.data.shows[1];
            //                       } else{
            //                       this.listingMovies = res.data.shows[2];
            //                       }
            // //                      console.log(arr);
            // //                      this.nowShowing = arr;
            // //                      this.slides.nowShowing =
            // //                          typeof data.nowShowing[0] !== undefined &&
            // //                          Object.keys(data.nowShowing[0]).length > 0
            // //                              ? data.nowShowing[0]
            //                              : null;
            // console.log("Data >>>", this.slides);
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/pages/error404.vue